/* ============================================================
   AndroidBuildView.jsx — Page /android-test (ADMIN) versi bersih
   ============================================================
   Hanya seksyen "Build shared default" (AndroidDefaultBuilder) — enjin resipi
   + Stepper + mirror + Save as default. Tool POC lama (AndroidAutoView:
   connection/inspector/configure/transfer) DIKEKALKAN dalam kod sebagai
   backup TAPI tidak lagi dirujuk route (elak dua sambungan telefon berasingan
   dalam satu page = mengelirukan; keputusan user 30 Okt).
   Route dipagar isAdmin + AdminPinGate dalam App.jsx.
   ============================================================ */

import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import '../design/tokens.css';
import '../design/ui.css';
import './AndroidAutoView.css';
import { isWebUsbSupported } from '../utils/androidAdb';
import { Segmented } from '../design/ui';
import AndroidDefaultBuilder from './AndroidDefaultBuilder';
// ★ [2026-11-04] Inspector phone admin (macam GenFarmer) — tab berasingan; hanya SATU tab
// dirender pada satu masa → satu sambungan phone sahaja (keputusan 30 Okt kekal).
import AndroidInspector from './AndroidInspector';

export default function AndroidBuildView() {
  const supported = isWebUsbSupported();
  const [tab, setTab] = useState(() => {
    try { return localStorage.getItem('sesaat_android_admin_tab_v1') || 'build'; } catch { return 'build'; }
  });
  const pilihTab = (v) => {
    setTab(v);
    try { localStorage.setItem('sesaat_android_admin_tab_v1', v); } catch { /* storan ditutup */ }
  };
  return (
    <div className="s-root aat-wrap">
      <header className="aat-head">
        <div>
          <h1 className="s-title">Android Automation — {tab === 'inspector' ? 'inspector' : 'build default'}</h1>
          <p className="s-subtitle">{tab === 'inspector'
            ? 'Admin only. Click any element on the phone screen to see how the robot can find it.'
            : 'Admin only. Run the Shopee post flow until it is smooth, then Save as default for all users.'}</p>
        </div>
        <Segmented value={tab} onChange={pilihTab} options={[{ value: 'build', label: 'Build default' }, { value: 'inspector', label: 'Inspector' }]} />
      </header>

      {!supported && (
        <div className="aat-alert">
          <AlertTriangle size={18} />
          <div>
            <strong>WebUSB not available in this browser.</strong><br />
            Open this page in <b>Google Chrome</b> on desktop (Windows).
          </div>
        </div>
      )}

      {tab === 'inspector' ? <AndroidInspector /> : <AndroidDefaultBuilder />}
    </div>
  );
}
